var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.025 3.712 1.06 1.06L5.6 13.258l-1.06-1.061z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.087 12.198-1.06 1.06L4.54 4.773l1.06-1.06z"
  })));
};
export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjEzLjAyNTQiIHk9IjMuNzExOTEiIHdpZHRoPSIxLjUiIGhlaWdodD0iMTIiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDEzLjAyNTQgMy43MTE5MSkiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cmVjdCB4PSIxNC4wODY5IiB5PSIxMi4xOTczIiB3aWR0aD0iMS41IiBoZWlnaHQ9IjEyIiB0cmFuc2Zvcm09InJvdGF0ZSgxMzUgMTQuMDg2OSAxMi4xOTczKSIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";